<template>
	<div class="col-md-4">
		<div class="form-group">
			<label>{{label}}<span class="required">*</span>
    </label>
			<input type="text" v-only-uppercase class="form-control text-uppercase" :id="name"
						 :name="name" v-validate="label.indexOf('Email')!=-1 ? 'required':'required|D2B_UPSTRING_DATA:'+length" :maxlength="length"
					  v-model="value[name]"		
					  :data-vv-as="label"				 
						 :placeholder="placeholder"/>
      <div v-show="errors.has(name)" class="help is-danger">{{errors.first(name)}}</div>
		</div>
	</div>
</template>
<script>
  export default {
  name: 'UPRSTRING',
  inject: ['$validator'],
  props: ['placeholder', 'label', 'name', 'value','required_message','length','regularexpression']
  }
</script>
